import { useEffect, useState } from "react";
import PieceList from "../../components/piece/pieceList";
import PieceFilter from "./pieceFilter";
import PieceFilterKeywordList from "./pieceFilterKeywordList";

import { Helmet } from "react-helmet";
import Dropdown from "../../components/dropdown";
import Loader from "../../components/loader";
import SearchBar from "../../components/searchBar";
import { useAppContext } from "../../context/appContext";
import { PieceFilterDTO, PieceFilterDTOOrderOptionEnum, PieceFilterResultDTO } from "../../openapi-generated-client";
import { deepObjectEqual, formatEnumValue } from "../../utils/objectUtils";
import useWindowDimensions from "../../utils/useWindowDimensions";
import PiecePageDisplay from "./piecePageDisplay";
import "./pieces.css";
import SearchBarWithDropdown from "../../components/searchBarWithDropdown";
import { isDeepStrictEqual } from "util";
import { useSearchParams } from "react-router-dom";
import { parsePieceFilterFromSearchParams } from "../../utils/parsePieceFilterFromSearchParams";

export default function PiecesPage() {

    const {pieceController} = useAppContext();
    const [searchParams, setSearchParams] = useSearchParams();


    const windowDimensions = useWindowDimensions();

    const defaultFilterBody = {
        search: "",
        orderOption: PieceFilterDTOOrderOptionEnum.MostRecent,
        currentPage: 0,
        keywords: [],
        instruments: undefined,
        totalInstrumentAmount: undefined,
        difficulties: undefined,
        durationFrom: undefined,
        durationTo: undefined,
        maxPrice: undefined,
        original: undefined,
        yearFrom: undefined,
        yearTo: undefined,
        instrumentationType: undefined,
        composerCountries: undefined,

    };

    const [data, setData] = useState<PieceFilterResultDTO | undefined>(undefined);
    const [filterBody, setFilterBody] = useState<PieceFilterDTO>(() => {
        return parsePieceFilterFromSearchParams(searchParams, defaultFilterBody);
    });

  // Clear URL params once after we've consumed them
  useEffect(() => {
    if (searchParams.size > 0) {
      // remove everything after "?"
      setSearchParams({}, { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

    const [expandFilter, setExpandFilter] = useState(false);

    const orderOptions = Object.values(PieceFilterDTOOrderOptionEnum).map(formatEnumValue);

    async function fetchData() {
        setData((await pieceController.filter(filterBody)).data);
    }


    useEffect(() => {
        fetchData();
    }, [filterBody]);

    if(!data) return <Loader/>;

    return <>
        <Helmet>
            <title>Pieces | Txoria</title>
            <meta name="description" content="Discover a wide range of sheet music for various instruments and difficulties. Filter by instrumentation, difficulty, and more to find the perfect piece for you or your ensemble." />
            <meta name="keywords" content="sheet music, pieces, ensemble, instrumentation, difficulty, Txoria" />
        </Helmet>
        <PieceFilter setMobileExpand={setExpandFilter} mobileExpand={windowDimensions.width < 1050 ? expandFilter : undefined} filterResult={data} body={filterBody} setBody={setFilterBody}/>
        <div className={"page pieces minHeight100" + (windowDimensions.width < 1050 ? " keep-margin" : " has-sidebar")}>
            <SearchBarWithDropdown search={filterBody.search} setSearch={(search) => setFilterBody({...filterBody, search})} dropdown={{
                prefix: "Sort by: ",
                options: orderOptions,
                selectedOption: Object.values(PieceFilterDTOOrderOptionEnum).indexOf(filterBody.orderOption),
                setSelectedOption: (id: number) => setFilterBody({...filterBody, orderOption: Object.values(PieceFilterDTOOrderOptionEnum)[id]}),
            }} headerPart={<>
                <div className="round-button" onClick={() => {
                    setExpandFilter(!expandFilter);
                }}>
                    <h5>Expand Filters {!deepObjectEqual(filterBody, defaultFilterBody) ? <div className="expanded-indicator"/> : <></>}</h5>
                </div>
            </>}>
                <h2>Keywords</h2>
                <PieceFilterKeywordList maxElements={windowDimensions.width < 600 ? 6 : 10} active={filterBody.keywords!} onUpdate={(keywords) => setFilterBody({...filterBody, keywords})} keywords={data?.keywords!}/>

            </SearchBarWithDropdown>
            <PieceList displayProps={{
                linkPrefix: "/pieces"
            }} pieces={data.pieces}/>
            <PiecePageDisplay currentPage={data.page} setCurrentPage={(page) => setFilterBody({...filterBody, currentPage: page})} totalPages={data.pagesAvailable}/>
        </div>
    </>;
}